// extracted by mini-css-extract-plugin
module.exports = {"root":"CardReaderDesc_root__24LLR","col":"CardReaderDesc_col__28x4r","label":"CardReaderDesc_label__30YTz"};